// Fórmulas de precio compartidas por la calculadora (/products-pos) y el formulario de productos.
export const IVA_RATE = 1.16

// El precio sin IVA se guarda con 6 decimales: si se redondea a 2, al volver a calcular
// el precio con IVA se pierde un centavo (935.00 / 1.16 = 806.03 -> 806.03 * 1.16 = 934.99).
export const PRICE_DECIMALS = 6

export function priceWithIva(price) {
  return (Number(price || 0) * IVA_RATE).toFixed(2)
}

export function priceWithoutIva(priceIva) {
  return Number((Number(priceIva || 0) / IVA_RATE).toFixed(PRICE_DECIMALS))
}
